import { actions } from "./state";

export const changeFormData = (props) => {
  return {
    type: actions.CHANGE_FORM_DATA,
    payload: props,
  };
};

export const changeRikjang = (props) => {
  return {
    type: actions.CHANGE_RIKJANG,
    payload: props,
  };
};

export const changeRikjangID = (props) => {
  return {
    type: actions.CHANGE_RIKJANG_ID,
    payload: props,
  };
};

export const changeListBarang = (props) => {
  return {
    type: actions.CHANGE_LIST_BARANG,
    payload: props,
  };
};

export const changeListJasa = (props) => {
  return {
    type: actions.CHANGE_LIST_JASA,
    payload: props,
  };
};

export const changeListFasilitas = (props) => {
  return {
    type: actions.CHANGE_LIST_FASILITAS,
    payload: props,
  };
};

export const changeFormHargaTarifBeli = (props) => {
  return {
    type: actions.CHANGE_FORM_HARGA_TARIF_BELI,
    payload: props,
  };
};

export const changeFormHargaTarifJual = (props) => {
  return {
    type: actions.CHANGE_FORM_HARGA_TARIF_JUAL,
    payload: props,
  };
};

export const changeFieldTarif = (props) => {
  return {
    type: actions.CHANGE_FIELD_TARIF,
    payload: props,
  };
};
